import _ from 'lodash'
import './capabilitiesField.scss'
import templateUrl from './capabilitiesField.html'

/**
 * Capabilities Field component.
 *
 * Presents a grouped list of checkboxes of registered capabilities.
 *
 * @example
 *   <tmr-capabilities-field checked="$ctrl.capabilities"></tmr-capabilities-field>
 *
 * @type {ngComponent}
 * @prop checked {array} List of selected capabilities (used as output)
 */
export const tmrCapabilitiesField = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrCapabilitiesFieldController',
  bindings: {
    checked: '=',
  },
}

/**
 * Controller of component {@link tmrCapabilitiesField}.
 *
 * @type {ngController}
 */
export class tmrCapabilitiesFieldController {
  static ngType = 'controller'

  constructor(TmrCapabilities) {
    'ngInject'
    Object.assign(this, { TmrCapabilities })
  }

  $onInit() {
    this.TmrCapabilities.get().then(capabilities => {
      this.capabilities = capabilities
      this.groups = this.TmrCapabilities.group(this.capabilities)
      this.models = this.TmrCapabilities.groupModels(this.groups, this.checked)
    })
  }

  toggleCapability(capability) {
    this.models[capability] = _.toggle(this.checked, capability)
  }

  toggleGroup(group) {
    // "Other" group is not really a group.
    if (this.models[group] === undefined) return

    this.toggleCapability(group)
    this.groups[group].capabilities.forEach(capability => {
      if (this.checked.indexOf(capability.capability) == -1) {
        this.models[capability.capability] = true
        this.checked.push(capability.capability)
      }
    })
  }

  removeGroup(group, capability) {
    if (this.models[group]) {
      this.models[group] = false
      this.checked.splice(this.checked.indexOf(group), 1)
    }
    // Toggle also clicked capability.
    this.toggleCapability(capability)
  }
}
